import { useSsSelector } from '~SpectateStore';
import {
    selectUserSelectionIds,
} from '~Betslip/selectors/userSelectionsSelectors';

export const useBetslipSelectionsIds = () => useSsSelector(selectUserSelectionIds);
